import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';

export class MultiLineEllipsisText extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      processedText: '',
    };

    this.hiddenTextRef = React.createRef();
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.processText();
  }

  componentDidUpdate() {
    this.processText();
  }

  processText = _.debounce(() => {
    if (!this.hiddenTextRef || !this.hiddenTextRef.current) {
      return;
    }

    this.hiddenTextRef.current.style.maxWidth = `${this.containerRef.current.clientWidth}px`;
    this.hiddenTextRef.current.style.position = 'absolute';

    const wordArray = this.props.text.split(' ');
    let newText = `${wordArray.join(' ')}`;
    this.hiddenTextRef.current.innerText = newText;

    while (this.hiddenTextRef.current.scrollHeight > this.containerRef.current.offsetHeight) {
      wordArray.pop();
      newText = `${wordArray.join(' ')}...`;

      if (this.hiddenTextRef.current.innerText === newText) {
        break;
      }

      this.hiddenTextRef.current.innerText = newText;
    }

    this.setState({
      processedText: `${newText}`,
    });
  }, 100);

  render() {
    return (
      <div
        className={`multi-line-ellipsis-text-component ${this.props.className}`}
        style={this.props.style}
        ref={this.containerRef}
      >
        <div
          className="multi-line-hidden-text"
          style={{ opacity: 0, zIndex: -2 }}
          ref={this.hiddenTextRef}
        />
        <div className="multi-line-processed-text">
          {this.state.processedText}
        </div>
      </div>
    );
  }
}

MultiLineEllipsisText.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

MultiLineEllipsisText.defaultProps = {
  className: undefined,
  style: undefined,
  text: '',
};
